<div class="range-field" role="group" [attr.aria-labelledby]="labelId">
  <div class="input-group">
    <input #box
      [id]="stringValueInputId"
      class="form-control"
      [class.textbox-invalid]="isValid === false"
      [(ngModel)]="stringValue"
      (change)="onStringValueChanged(box.value)"
      [attr.maxlength]="stringValueLength"
      [attr.readonly]="isOpen ? 'readonly' : null"
      [attr.aria-invalid]="isValid === false ? 'true' : 'false'"
      />
    <div class="input-group-append">
      <button
        type="button"
        class="btn btn-default btn-form-default"
        (click)="isOpen = !isOpen"
        [attr.aria-label]="isOpen ? ('components.rangeField.closeRangeValuesFor' | translate : { label: field.label }) : ('components.rangeField.openRangeValuesFor' | translate : { label: field.label })"
        [title]="isOpen ? ('components.rangeField.closeRangeValues' | translate) : ('components.rangeField.openRangeValues' | translate)"
        [attr.aria-expanded]="isOpen ? 'true' : 'false'"
        [attr.aria-controls]="stringValueInputId + '-values'"
      >
        <i
          [class]="isOpen ? 'fas fa-chevron-up' : 'fas fa-chevron-down'"
          aria-hidden="true"
        ></i>
      </button>
    </div>
  </div>
  <fieldset 
    [id]="stringValueInputId + '-values'" 
    class="range-field-values"
    [attr.hidden]="!isOpen ? 'hidden' : null"
    [attr.tabindex]="!isOpen ? '-1' : null">
    <legend class="sr-only">{{ 'components.rangeField.rangeValuesFor' | translate : { label: field.label } }}</legend>
    <div>
      <div class="form-label">{{ 'components.rangeField.from' | translate }}</div>
      <div class="input-group">
        <select 
          [id]="stringValueInputId + '-min-operator'"
          class="form-control operator-select"          
          [(ngModel)]="minOperator"
          (ngModelChange)="onValuesChanged()"
          [attr.aria-label]="('components.rangeField.operatorForMinValue' | translate)"
          [title]="('components.rangeField.operatorForMinValue' | translate)">
          <option *ngFor="let item of operatorItems" [ngValue]="item">{{ item }}</option>
        </select>
        <input
          #minValueModel="ngModel"
          [id]="stringValueInputId + '-min-value'"
          class="form-control"
          appNumericValidator
          [(ngModel)]="minValue"
          (ngModelChange)="onValuesChanged()"
          [class.textbox-invalid]="minValueModel.invalid && minValueModel.touched"
          [attr.aria-invalid]="(minValueModel.invalid && minValueModel.touched) ? 'true' : 'false'"
          [attr.aria-label]="('components.rangeField.valueForMinValue' | translate)"
          [attr.placeholder]="('components.rangeField.valueForMinValue' | translate)">
        <select *ngIf="hasUnits"
          [id]="stringValueInputId + '-min-unit'"
          class="form-control unit-select"          
          [(ngModel)]="minUnitInternal"
          (ngModelChange)="onValuesChanged()"
          [attr.aria-label]="('components.rangeField.unitForMinValue' | translate)"
          [title]="('components.rangeField.unitForMinValue' | translate)">
          <option *ngFor="let item of unitItems" [ngValue]="item">{{ item }}</option>
        </select>
      </div>
    </div>
    <div *ngIf="hasMaxValue">
      <div class="form-label">{{ 'components.rangeField.to' | translate }}</div>
      <div class="input-group">
        <select 
          [id]="stringValueInputId + '-max-operator'"
          class="form-control operator-select"          
          [(ngModel)]="maxOperator"
          (ngModelChange)="onValuesChanged()"
          [attr.aria-label]="('components.rangeField.operatorForMaxValue' | translate)"
          [title]="('components.rangeField.operatorForMaxValue' | translate)">
          <option *ngFor="let item of operatorItems" [ngValue]="item">{{ item }}</option>
        </select>
        <input
          #maxValueModel="ngModel"
          [id]="stringValueInputId + '-max-value'"
          class="form-control"
          appNumericValidator
          [(ngModel)]="maxValue"
          (ngModelChange)="onValuesChanged()"
          [class.textbox-invalid]="maxValueModel.invalid && maxValueModel.touched"
          [attr.aria-invalid]="(maxValueModel.invalid && maxValueModel.touched) ? 'true' : 'false'"
          [attr.aria-label]="('components.rangeField.valueForMaxValue' | translate)"
          [attr.placeholder]="('components.rangeField.valueForMaxValue' | translate)">
        <select *ngIf="hasUnits"
          [id]="stringValueInputId + '-max-unit'"
          class="form-control unit-select"          
          [(ngModel)]="maxUnitInternal"
          (ngModelChange)="onValuesChanged()"
          [attr.aria-label]="('components.rangeField.unitForMaxValue' | translate)"
          [title]="('components.rangeField.unitForMaxValue' | translate)">
          <option *ngFor="let item of unitItems" [ngValue]="item">{{ item }}</option>
        </select>
      </div>
    </div>
    <div>
      <label [for]="stringValueInputId + '-description'">{{ 'components.rangeField.description' | translate }}</label>
      <textarea
        [id]="stringValueInputId + '-description'"
        class="form-control"
        [ngClass]="{ filled: description?.length > 0 }"
        [(ngModel)]="description"
        (ngModelChange)="onValuesChanged()"          
        [attr.maxlength]="stringDescriptionLength"
      ></textarea>
    </div>
    <div *ngIf="plausibilityItems && plausibilityItems.length > 1">
      <label [for]="stringValueInputId + '-plausibility'">{{ 'components.rangeField.plausibility' | translate }}</label>
      <select 
        [id]="stringValueInputId + '-plausibility'"
        class="form-control"          
        [(ngModel)]="plausibility"
        (ngModelChange)="onValuesChanged()">
        <option *ngFor="let item of plausibilityItems" [ngValue]="item">{{ item }}</option>
      </select>
    </div>    
  </fieldset>
</div>
